import { create } from "zustand";
import { FieldDetailInfoModalSliceProps } from "./lib/type";
import { modalBaseSlice } from "./slices/baseToggleSlice";

export const useFieldDetailInfoModal = create<FieldDetailInfoModalSliceProps>(
  (set, get, api) => ({
    ...modalBaseSlice(set, get, api),
    title: "",
    description: "",
    open: (payload) => set(() => ({  ...payload, isOpen: true }))
  }),
);
